import type { IconData } from '@stacksjs/iconify-core'

export const sitemap: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M472 328h-24v-64a24.027 24.027 0 0 0-24-24H272v-64h32a24.03 24.03 0 0 0 24-24V80a24.03 24.03 0 0 0-24-24h-96a24.03 24.03 0 0 0-24 24v72a24.03 24.03 0 0 0 24 24h32v64H88a24.027 24.027 0 0 0-24 24v64H40a24.03 24.03 0 0 0-24 24v72a24.03 24.03 0 0 0 24 24h80a24.03 24.03 0 0 0 24-24v-72a24.03 24.03 0 0 0-24-24H96v-56h144v56h-24a24.03 24.03 0 0 0-24 24v72a24.03 24.03 0 0 0 24 24h80a24.03 24.03 0 0 0 24-24v-72a24.03 24.03 0 0 0-24-24h-24v-56h144v56h-24a24.03 24.03 0 0 0-24 24v72a24.03 24.03 0 0 0 24 24h80a24.03 24.03 0 0 0 24-24v-72a24.03 24.03 0 0 0-24-24M216 88h80v56h-80ZM112 360v56H48v-56Zm176 0v56h-64v-56Zm176 56h-64v-56h64Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default sitemap
